import React, { useState, useEffect} from "react";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import CurateProductCont from "./CurateProductCont";

const CurateProduct = () => {
  document.title = "Curate Name";

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col lg={12}>
                <Card>
                  {/* <CardHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2 className="card-title mb-0">Curate Name</h2>
                  </CardHeader> */}
                  <CardBody>
                    <CurateProductCont/>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
};

export default CurateProduct;
